import React, {Component, Fragment} from 'react';
import moment from 'moment';
import Datepicker from '../Datepicker/Datepicker.js';
import DatepickerHours from '../Datepicker/DatepickerHours.js';
import {connect} from "react-redux";
import {getDeliveryDetails} from "../../actionCreators";

class DeliveryDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isRendered: true,
      isSubmittedForm: false,
      countDatepicker: 0,
      startDates: [{}, {}, {}],
      today: moment().toDate(),
      endToday: moment().endOf('day').toDate()
    }
  }
  // moment(new Date()).add(2,'days').toDate()
  handleChange = (index, date) => {
    const {startDates, countDatepicker} = this.state;
    const tempStartDates = startDates;
    const tempArr = [];
    for(let i=0; i<=countDatepicker; i++) {
      let item = moment(date).add(i, 'days').toDate();
      tempArr.push(item);
    }

    if (tempStartDates[index] !== undefined) {
      tempStartDates[index].day = date;
      tempStartDates[index].excludeDates = tempArr;

      tempStartDates[index].from = undefined;
      tempStartDates[index].to = undefined;
      tempStartDates[index].excludeFrom = undefined;
      tempStartDates[index].excludeTo = undefined;
    } else {
      const tempObj = {};
      tempObj.day = date;
      tempObj.excludeDates = tempArr;

      tempObj.from = undefined;
      tempObj.to = undefined;
      tempObj.excludeFrom = undefined;
      tempObj.excludeTo = undefined;

      tempStartDates.push(tempObj)
    }
    this.setState({
      startDates: tempStartDates
    });
  };

  handleChangeHours = (index, date, fromto) => {
    const {startDates} = this.state;
    const tempStartDates = startDates;
    let tempDate = tempStartDates[index].day;
    let tempDateH = moment(date).format("HH");
    let tempDatee = moment(tempDate).set({hour:tempDateH,minute:0,second:0,millisecond:0}).toDate()
    const tempArr = [];
    for(let i=-2; i<3; i++) {
      let item = moment(tempDatee).add(i, 'hours').toDate();
      tempArr.push(item);
    }

    if (tempStartDates[index] !== undefined) {
      fromto === 'from' ? tempStartDates[index].from = tempDatee : tempStartDates[index].to = tempDatee;
      fromto === 'from' ? tempStartDates[index].excludeFrom = tempArr : tempStartDates[index].excludeTo = tempArr;
    } else {
      const tempObj = {};
      fromto === 'from' ? tempObj.from = tempDatee : tempObj.to = tempDatee;
      fromto === 'from' ? tempObj.excludeFrom = tempArr : tempObj.excludeTo = tempArr;
      tempStartDates.push(tempObj)
    }
    this.setState({
      startDates: tempStartDates
    });
  };

  handleDateChangeRaw = (e) => {
    e.preventDefault();
  };

  handleNextStepBtn = () => {
    const {handleNextStep, getDeliveryDetails} = this.props;
    const {startDates} = this.state;
    const {equalTimes} = this;

    this.setState({
      isSubmittedForm: true
    });

    const dataDetails = startDates;

    if(
      // true
      startDates && startDates[0].day &&
      startDates && startDates[0].excludeFrom &&
      startDates && startDates[0].excludeTo &&
      startDates && startDates[1].day &&
      startDates && startDates[1].excludeFrom &&
      startDates && startDates[1].excludeTo &&
      startDates && startDates[2].day &&
      startDates && startDates[2].excludeFrom &&
      startDates && startDates[2].excludeTo &&
      equalTimes(0) &&
      equalTimes(1) &&
      equalTimes(2)
    ) {
      getDeliveryDetails(dataDetails);
      handleNextStep();
    } else {
      console.log('S2 not send ajax')
    }
  };

  equalTimes = (index) => {
    const {startDates} = this.state;
    const mStart = startDates && moment(startDates[index].from);
    const mEnd = startDates && moment(startDates[index].to);
    return mStart.isBefore(mEnd)
  };

  convertToDate = (date) => {
    return moment(date).toDate();
  }

  getStartDate = (dateIndex, fromto) => {
    const {startDates} = this.state;
    if(fromto === 'from') {
      return startDates[dateIndex] ? startDates[dateIndex].from : null;
    }
    if(fromto === 'to') {
      return startDates[dateIndex] ? startDates[dateIndex].to : null;
    }
    return startDates[dateIndex] ? startDates[dateIndex].day : null;
  };

  componentDidMount() {
    const {convertToDate} = this;
    const {deliveryDetails} = this.props;
    const {isRendered} = this.state;
    if(deliveryDetails && isRendered) {
      for(let i=0; i<3; i++) {
        deliveryDetails[i].day = convertToDate(deliveryDetails[i].day);
        deliveryDetails[i].from = convertToDate(deliveryDetails[i].from);
        deliveryDetails[i].to = convertToDate(deliveryDetails[i].to);
        deliveryDetails[i].excludeDates = [].concat.apply([], deliveryDetails[i].excludeDates.map(k => moment(k).toDate()));
        deliveryDetails[i].excludeTo = [].concat.apply([], deliveryDetails[i].excludeTo.map(k => moment(k).toDate()));
        deliveryDetails[i].excludeFrom = [].concat.apply([], deliveryDetails[i].excludeFrom.map(k => moment(k).toDate()));
      }
      this.setState({
        startDates: deliveryDetails
      })
      this.setState({
        isRendered: false
      })
    }
  }

  excludeTimes = (index) => {
    if(this.state.startDates[index].excludeFrom) {
      var toDate = moment(this.state.startDates[index].excludeFrom[4]).toDate();
      var fromDate = moment(toDate).hours(8).minutes(0).toDate();

      var toDateHour = moment(toDate).format("HH");
      var fromDateHour = moment(fromDate).format("HH");

      var diffHours = toDateHour - fromDateHour + 1;
      var tempArr = [];
      for(var i=0; i<diffHours; i++) {
        tempArr.push(moment(fromDate).add(i, 'hours').toDate());
      }
      return tempArr;
    }
  }

  render() {
    const {getStartDate, handleChange, handleChangeHours, handleDateChangeRaw, handleNextStepBtn, equalTimes, excludeTimes} = this;
    const {startDates, today, endToday, isSubmittedForm} = this.state;
    const {deliveryDetails} = this.props;
    const excludeDates = [].concat.apply([], this.state.startDates.map(k => k.excludeDates));

    return (
      <Fragment>
      <section className="delivery-details">
        <h2>Lieferdetails</h2>
        <div className="delivery-details__wrap">
          <div className="delivery-details__time">
            <h3>Wann dürfen wir deine Ware liefern? Hier kannst du uns 3 Vorschläge machen</h3>
            <div className="delivery-details__row">
              <div className={"input-wrap input-wrap--common " + (startDates && !startDates[0].day && isSubmittedForm ? 'form__error' : '')}>
                <label>Datum</label>
                <Datepicker
                  deliveryDetails={deliveryDetails}
                  today={today}
                  numberDatepicker={0}
                  getStartDate={getStartDate}
                  handleChange={handleChange}
                  getExcludeDates={excludeDates}
                  handleDateChangeRaw={handleDateChangeRaw}
                />
              </div>
              <div className={"input-wrap input-wrap--common " + (startDates && !startDates[0].excludeFrom && isSubmittedForm ? 'form__error' : '')}>
                <label>von</label>
                <DatepickerHours
                  deliveryDetails={deliveryDetails}
                  state={this.state}
                  today={today}
                  fromto={'from'}
                  tomorrow={endToday}
                  numberDatepicker={0}
                  getStartDate={getStartDate}
                  handleChange={handleChangeHours}
                  getExcludeDates={[].concat.apply([], [this.state.startDates[0].excludeFrom ,this.state.startDates[0].excludeTo])}
                  handleDateChangeRaw={handleDateChangeRaw}
                  numberHourPicker={'1'}
                  isDisabledHourPicker={this.state.startDates[0].excludeFrom}
                />
              </div>
              <div className={"input-wrap input-wrap--common " + (startDates && !startDates[0].excludeTo && isSubmittedForm ? 'form__error' : '')}>
              <label>bis</label>
                <DatepickerHours
                  deliveryDetails={deliveryDetails}
                  today={today}
                  fromto={'to'}
                  tomorrow={endToday}
                  numberDatepicker={0}
                  getStartDate={getStartDate}
                  handleChange={handleChangeHours}
                  getExcludeDates={excludeTimes(0)}
                  handleDateChangeRaw={handleDateChangeRaw}
                  numberHourPicker={'2'}
                  isDisabledHourPicker={this.state.startDates[0].excludeFrom}
                />
              </div>
            </div>
            { !equalTimes(0) && isSubmittedForm ? (<div className={"form__error form__error--details"}>Zeitfenster ungültig</div>) : ('')}
            <div className="delivery-details__row">
              <div className={"input-wrap input-wrap--common " + (startDates && !startDates[1].day && isSubmittedForm ? 'form__error' : '')}>
                <label>Datum</label>
                <Datepicker
                  deliveryDetails={deliveryDetails}
                  today={today}
                  numberDatepicker={1}
                  getStartDate={getStartDate}
                  handleChange={handleChange}
                  getExcludeDates={excludeDates}
                  handleDateChangeRaw={handleDateChangeRaw}
                />
              </div>
              <div className={"input-wrap input-wrap--common " + (startDates && !startDates[1].excludeFrom && isSubmittedForm ? 'form__error' : '')}>
                <label>von</label>
                <DatepickerHours
                  deliveryDetails={deliveryDetails}
                  today={today}
                  fromto={'from'}
                  tomorrow={endToday}
                  numberDatepicker={1}
                  getStartDate={getStartDate}
                  handleChange={handleChangeHours}
                  getExcludeDates={[].concat.apply([], [this.state.startDates[1].excludeFrom ,this.state.startDates[1].excludeTo])}
                  handleDateChangeRaw={handleDateChangeRaw}
                  numberHourPicker={'1'}
                  isDisabledHourPicker={this.state.startDates[1].excludeFrom}
                />
              </div>
              <div className={"input-wrap input-wrap--common " + (startDates && !startDates[1].excludeTo && isSubmittedForm ? 'form__error' : '')}>
                <label>bis</label>
                <DatepickerHours
                  deliveryDetails={deliveryDetails}
                  today={today}
                  fromto={'to'}
                  tomorrow={endToday}
                  numberDatepicker={1}
                  getStartDate={getStartDate}
                  handleChange={handleChangeHours}
                  getExcludeDates={excludeTimes(1)}
                  handleDateChangeRaw={handleDateChangeRaw}
                  numberHourPicker={'2'}
                  isDisabledHourPicker={this.state.startDates[1].excludeFrom}
                />
              </div>
            </div>
            { !equalTimes(1) && isSubmittedForm ? (<div className={"form__error form__error--details"}>Zeitfenster ungültig</div>) : ('')}
            <div className="delivery-details__row">
              <div className={"input-wrap input-wrap--common " + (startDates && !startDates[2].day && isSubmittedForm ? 'form__error' : '')}>
                <label>Datum</label>
                <Datepicker
                  deliveryDetails={deliveryDetails}
                  today={today}
                  numberDatepicker={2}
                  getStartDate={getStartDate}
                  handleChange={handleChange}
                  getExcludeDates={excludeDates}
                  handleDateChangeRaw={handleDateChangeRaw}
                />
              </div>
              <div className={"input-wrap input-wrap--common " + (startDates && !startDates[2].excludeFrom && isSubmittedForm ? 'form__error' : '')}>
                <label>von</label>
                <DatepickerHours
                  deliveryDetails={deliveryDetails}
                  today={today}
                  fromto={'from'}
                  tomorrow={endToday}
                  numberDatepicker={2}
                  getStartDate={getStartDate}
                  handleChange={handleChangeHours}
                  getExcludeDates={[].concat.apply([], [this.state.startDates[2].excludeFrom ,this.state.startDates[2].excludeTo])}
                  handleDateChangeRaw={handleDateChangeRaw}
                  numberHourPicker={'1'}
                  isDisabledHourPicker={this.state.startDates[2].excludeFrom}
                />
              </div>
              <div className={"input-wrap input-wrap--common " + (startDates && !startDates[2].excludeTo && isSubmittedForm ? 'form__error' : '')}>
                <label>bis</label>
                <DatepickerHours
                  deliveryDetails={deliveryDetails}
                  today={today}
                  fromto={'to'}
                  tomorrow={endToday}
                  numberDatepicker={2}
                  getStartDate={getStartDate}
                  handleChange={handleChangeHours}
                  getExcludeDates={excludeTimes(2)}
                  handleDateChangeRaw={handleDateChangeRaw}
                  numberHourPicker={'2'}
                  isDisabledHourPicker={this.state.startDates[2].excludeFrom}
                />
              </div>
            </div>
            { !equalTimes(2) && isSubmittedForm ? (<div className={"form__error form__error--details"}>Zeitfenster ungültig</div>) : ('')}
          </div>
        </div>
      </section>
      <button className="shop-btn shop-btn--next shop-btn--common shop-btn-right--common" onClick={handleNextStepBtn} />
      </Fragment>
    );
  }
}

export default connect((state) => {
  return {
    deliveryDetails: state.delivery.deliveryDetails
  }
}, {getDeliveryDetails})(DeliveryDetails);


// WEBPACK FOOTER //
// ./src/components/DeliverySteps/DeliveryDetails.js